import { render } from "./DisabilityUpdatePage.vue?vue&type=template&id=28e71720&scoped=true"
import script from "./DisabilityUpdatePage.vue?vue&type=script&lang=js"
export * from "./DisabilityUpdatePage.vue?vue&type=script&lang=js"

import "./DisabilityUpdatePage.vue?vue&type=style&index=0&id=28e71720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e71720"]])

export default __exports__